<app-loading></app-loading>
<mat-drawer-container #contentMatDrawer class="content-mat-drawer mat-elevation-z2 p-0">

  <mat-sidenav-container class="sidenav-container" *ngIf="isAuthenticated" (backdropClick)="toggleSidenav()">
    <mat-sidenav [mode]="isMobileView ? 'over' : 'side'" class="sidenav" #drawer [opened]="!isSidenavOpen">

      <mat-card class="user-info-card border-bottom mb-4" routerLink="dashboard">
        <mat-icon class="mat-icon-round">person</mat-icon>
        <mat-card-header>
          <mat-card-title>
            <span>{{ usuario }}</span>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <span>{{ roles }}</span>
        </mat-card-content>
      </mat-card>

      <mat-accordion [multi]="false">
        <mat-expansion-panel *ngIf="hasSomePermission([
        'pais-index',
        'estado-index',
        'regimenFiscal-index',
        'tipoComprobante-index',
        'metodoDePago-index',
        'comprobanteMetodoPago-index',
        'giroComercial-index',
        'tipoCredito-index',
        permisosTipoSeguimientoNegocio.index,
        permisosEstatusSeguimientoNegocio.index,
        permisosUnidadMedida.index,
        permisosMetaActivacion.index,
        permisosExperienciaAgente.index,
        permisosImpuestoProducto.index
        ])">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="mat-icon-round">home</mat-icon>
              Catálogos
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item routerLink="catalogos/pais" *ngIf="hasPermission('pais-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                País
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/estado" *ngIf="hasPermission('estado-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Estado
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/regimenFiscal" *ngIf="hasPermission('regimenFiscal-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Régimen fiscal
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/tipoComprobante" *ngIf="hasPermission('tipoComprobante-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Tipo de comprobante
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/metodoPago" *ngIf="hasPermission('metodoDePago-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Método de pago
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/comprobanteMetodoPago"
               *ngIf="hasPermission('comprobanteMetodoPago-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Tipo de ticket
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/giroComercial" *ngIf="hasPermission('giroComercial-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Giro comercial
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/tipoCredito" *ngIf="hasPermission('tipoCredito-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Tipo de crédito
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/tipoSeguimientoNegocio"
               *ngIf="hasPermission(permisosTipoSeguimientoNegocio.index)">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Tipo de seguimiento
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/estatusSeguimientoNegocio"
               *ngIf="hasPermission(permisosEstatusSeguimientoNegocio.index)">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Estatus de seguimiento
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/unidadMedida" *ngIf="hasPermission(permisosUnidadMedida.index)">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Unidad de medida
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/metaActivacion" *ngIf="hasPermission(permisosMetaActivacion.index)">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Metas de activación
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/experienciaAgente"
               *ngIf="hasPermission(permisosExperienciaAgente.index)">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Experiencia de agentes
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/impuestosProducto"
               *ngIf="hasPermission(permisosImpuestoProducto.index)">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Impuestos de productos
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="catalogos/ticketCategoria"
              >
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Categoría de ticket
              </mat-panel-title>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>
        <mat-expansion-panel
          *ngIf="hasSomePermission([
                                    'configuracionCaja-index',
                                    'configuracionCobroMes-index',
                                    'empresaCredencial-index',
                                    'variableSistema-index'
                                    ])"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="mat-icon-round">settings</mat-icon>
              Configuración
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item routerLink="configuraciones/configuracionCaja"
               *ngIf="hasPermission('configuracionCaja-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Cajas
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="configuraciones/configuracionPlan"
               *ngIf="hasPermission('configuracionCaja-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Planes licencia
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="configuraciones/periodoDePago"
               *ngIf="hasPermission('configuracionCobroMes-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Periodos de pago
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="configuraciones/credencialesFacturacion"
               *ngIf="hasPermission('empresaCredencial-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Credenciales facturación
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="configuraciones/variablesSistema"
               *ngIf="hasPermission('variableSistema-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Variables del sistema
              </mat-panel-title>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>
        <mat-expansion-panel
          *ngIf="hasSomePermission([
          'empresa-index',
          'user-index',
          'role-index',
          'credencialElectronico-index'
           ])">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="mat-icon-round">corporate_fare</mat-icon>
              Empresas
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item routerLink="empresas/user" *ngIf="hasPermission('user-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Usuarios
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="empresas/role" *ngIf="hasPermission('role-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Roles
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="empresas/credencialesFacturacion"
               *ngIf="hasPermission('credencialElectronico-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Credenciales facturación
              </mat-panel-title>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="hasSomePermission([
        permisosNegocio.index,
        'sucursal-index',
        'caja-index',
        'cajero-index',
        'caja-index',
        ])">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="mat-icon-round">storefront</mat-icon>
              Negocios
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item routerLink="negocios/negocio" *ngIf="hasPermission(permisosNegocio.index)">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Negocios
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="negocios/tablero" *ngIf="hasPermission(permisosNegocio.index)">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Tablero
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="negocios/tendero" *ngIf="hasPermission('tendero-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Tenderos
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="negocios/sucursales" *ngIf="hasPermission('sucursal-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Sucursales
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="negocios/cajero" *ngIf="hasPermission('cajero-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Cajeros
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="negocios/caja" *ngIf="hasPermission('caja-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Cajas
              </mat-panel-title>
            </a>
            <mat-expansion-panel *ngIf="hasSomePermission([
            'comunicado-index',
            'buzon-index',
            'horarioSoporte-index',
            'credencialElectronico-index',
            'pagoDetalle-index'
            ]) || seguridadService.isAdmin() || seguridadService.isSoporte()">
              <mat-expansion-panel-header class="p-0 pr-4">
                <mat-panel-title>
                  <mat-icon class="mr-0">horizontal_rule</mat-icon>
                  Administrativo
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list>
                <a mat-list-item routerLink="negocios/documentos" *ngIf="hasSomePermission([
                'configuracionDistribucion-marcaBlanca',
                'configuracionDistribucion-aprobarMarca',
                'configuracionDistribucion-rechazarMarca',
                'configuracionDistribucion-aprobarDocumento',
                'configuracionDistribucion-rechazarDocumento',
                ])">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Documentación
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="negocios/comunicado" *ngIf="hasPermission('comunicado-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Comunicados
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="negocios/publicidad" *ngIf="hasPermission('comunicado-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Publicidad
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="negocios/buzon" *ngIf="hasPermission('buzon-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Buzón
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="negocios/horarioSoporte" *ngIf="hasPermission('horarioSoporte-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Horarios de soporte
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="negocios/historialChat" *ngIf="hasPermission('horarioSoporte-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Historial de chats
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="negocios/ticketSoporte"
                >
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Tickets Soporte
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="negocios/diagnosticoSesiones"
                   *ngIf="seguridadService.isAdmin() || seguridadService.isSoporte()">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Diagnóstico de sesiones
                  </mat-panel-title>
                </a>
              </mat-nav-list>
            </mat-expansion-panel>
            <a mat-list-item routerLink="negocios/credencialElectronico"
               *ngIf="hasPermission('credencialElectronico-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Credenciales
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="negocios/licencia" *ngIf="hasPermission('pagoDetalle-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Licencias
              </mat-panel-title>
            </a>
            <mat-expansion-panel *ngIf="hasSomePermission([
            'producto-index',
            'servicio-index',
            'paquete-index'
            ])">
              <mat-expansion-panel-header class="p-0 pr-4">
                <mat-panel-title>
                  <mat-icon class="mr-0">horizontal_rule</mat-icon>
                  Productos
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list>
                <a mat-list-item routerLink="negocios/productos/producto" *ngIf="hasPermission('producto-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Productos
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="negocios/productos/servicio" *ngIf="hasPermission('servicio-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Servicios
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="negocios/productos/paquete" *ngIf="hasPermission('paquete-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Paquetes
                  </mat-panel-title>
                </a>
              </mat-nav-list>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="hasSomePermission([
            'cliente-index',
            'credito-index',
            ])">
              <mat-expansion-panel-header class="p-0 pr-4">
                <mat-panel-title>
                  <mat-icon class="mr-0">horizontal_rule</mat-icon>
                  Clientes
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list>
                <a mat-list-item routerLink="negocios/clientes" *ngIf="hasPermission('cliente-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Clientes
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="negocios/clientes/credito" *ngIf="hasPermission('credito-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Crédito
                  </mat-panel-title>
                </a>
              </mat-nav-list>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="hasSomePermission([
              'repartidor-index',
              'pedido-index',
              'motivo-index',
            ])">
              <mat-expansion-panel-header class="p-0 pr-4">
                <mat-panel-title>
                  <mat-icon class="mr-0">horizontal_rule</mat-icon>
                  Ecommerce
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list>
                <a mat-list-item routerLink="ecommerce/repartidor" *ngIf="hasPermission('repartidor-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Repartidores
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="ecommerce/pedido" *ngIf="hasPermission('pedido-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Pedidos
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="ecommerce/motivo" *ngIf="hasPermission('motivo-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Motivos cancelación
                  </mat-panel-title>
                </a>
              </mat-nav-list>
            </mat-expansion-panel>
          </mat-nav-list>
        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="hasSomePermission([
        'venta-index',
        'factura-index',
        'cajaLog-index',
        'inventarioLog-index',
        'monederoElectronico-index',
        'creditoAdeudo-index',
        ])">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="mat-icon-round">list_alt</mat-icon>
              Reportes
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list>
            <a mat-list-item routerLink="reportes/venta" *ngIf="hasPermission('venta-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Ventas
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="reportes/movimientosProducto" *ngIf="hasPermission('inventarioLog-index')">
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Movimiento de productos
              </mat-panel-title>
            </a>
            <mat-expansion-panel *ngIf="hasSomePermission([
            'monederoElectronico-index',
            'creditoAdeudo-index',
            'factura-index',
            ])">
              <mat-expansion-panel-header class="p-0 pr-4">
                <mat-panel-title>
                  <mat-icon class="mr-0">horizontal_rule</mat-icon>
                  Clientes
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list>
                <a mat-list-item routerLink="reportes/factura" *ngIf="hasPermission('factura-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Facturas
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="reportes/monederoElectronico"
                   *ngIf="hasPermission('monederoElectronico-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Monedero electrónico
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="reportes/creditos" *ngIf="hasPermission('creditoAdeudo-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Créditos
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="reportes/apartados" *ngIf="hasPermission('creditoAdeudo-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Apartados
                  </mat-panel-title>
                </a>
              </mat-nav-list>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="hasSomePermission([
            'inventario-index',
            'dineroInventario-index',
            'reportes-reporteCorteInventario',
            ])">
              <mat-expansion-panel-header class="p-0 pr-4">
                <mat-panel-title>
                  <mat-icon class="mr-0">horizontal_rule</mat-icon>
                  Inventario
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list>
                <a mat-list-item routerLink="reportes/existenciaMinima" *ngIf="hasPermission('inventario-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Existencia mínima
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="reportes/dineroInventario" *ngIf="hasPermission('dineroInventario-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Dinero en Inventario
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="reportes/cortesInventario"
                   *ngIf="hasPermission('reportes-reporteCorteInventario')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Cortes de Inventario
                  </mat-panel-title>
                </a>
              </mat-nav-list>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="hasSomePermission([
            'cajaLog-index',
            ])">
              <mat-expansion-panel-header class="p-0 pr-4">
                <mat-panel-title>
                  <mat-icon class="mr-0">horizontal_rule</mat-icon>
                  Cajas
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list>
                <a mat-list-item routerLink="reportes/movimientosCajas" *ngIf="hasPermission('cajaLog-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Movimientos
                  </mat-panel-title>
                </a>
                <a mat-list-item routerLink="reportes/cortesCajas" *ngIf="hasPermission('dineroInventario-index')">
                  <mat-panel-title>
                    <mat-icon>horizontal_rule</mat-icon>
                    Cortes
                  </mat-panel-title>
                </a>
              </mat-nav-list>
            </mat-expansion-panel>
          </mat-nav-list>
          <mat-nav-list>
          </mat-nav-list>
        </mat-expansion-panel>
        <mat-expansion-panel
          *ngIf="hasSomePermission([
            permisosPagoComisionAgenteLog.index,
           permisosSaldoAgente.index
           ])">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="mat-icon-round">support_agent</mat-icon>
              Agentes
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item routerLink="agentes/configuracionAgente"
               *ngIf="hasPermission(permisosConfiguracionAgente.index)"
            >
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Configuración de agentes
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="agentes/saldoAgente"
               *ngIf="hasPermission(permisosSaldoAgente.index)"
            >
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Saldo de agentes
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="agentes/movimientoSaldo"
               *ngIf="hasPermission(permisosPagoComisionAgenteLog.index)"
            >
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Movimientos de saldo
              </mat-panel-title>
            </a>
            <a mat-list-item routerLink="agentes/cumplimientoMeta"
               *ngIf="hasPermission(permisosCumplimientoMeta.index)"
            >
              <mat-panel-title>
                <mat-icon>horizontal_rule</mat-icon>
                Cumplimiento de meta
              </mat-panel-title>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-sidenav>

    <mat-sidenav-content>
      <mat-toolbar class="toolbar-header-principal bg-primario">
        <button mat-icon-button (click)="toggleSidenav()">
          <mat-icon>menu</mat-icon>
        </button>

        <span class="spacer"></span>
        <label CLASS="font-size-20 ml-1" *ngIf="seguridadService.isVentas()">SALDO <strong
          class="ml-1 tc-terciario-50">{{ saldoAgente | currency }}</strong></label>

        <span class="spacer"></span>

        <button mat-raised-button
                matBadgeSize="large"
                [matBadge]="totalSeguimientoProgramadoNegocio"
                [matBadgeHidden]="totalSeguimientoProgramadoNegocio == 0" matBadgeColor="warn"
                class="mr-3 bg-terciario-50 mat-badge-cuartenario"
                [matMenuTriggerFor]="seguimientoProgramado"
        >
          <mat-icon>access_alarm</mat-icon>
          Seguimientos programados
        </button>

        <mat-menu #seguimientoProgramado="matMenu" class="mt-1 p-3 bg-blanco">
          @if (totalSeguimientoProgramadoNegocio > 0) {
            <mat-card
              (click)="$event.stopPropagation()"
              class="mat-elevation-z8 bg-transparent mt-3"
              *ngFor="let snp of seguimientoProgramadoNegocioList; let i= index">
              <mat-card-header>
                <mat-card-title class="font-size-16 tc-primario">
                  {{ snp.negocio.id }} - {{ snp.negocio.nombre }}
                </mat-card-title>
              </mat-card-header>
              <mat-card-content class="mt-2">
                <div class="row gap-0">
                  <label class="content-info-fila col-12">
                    <b class="fz-title-fila-tabla mr-2">Teléfono:</b>
                    <span>{{ snp.negocio.telefono }}</span>
                  </label>
                  <label class="content-info-fila col-12">
                    <b class="mr-2">Email:</b>
                    <span>{{ snp.negocio.email }}</span>
                  </label>
                  <label class="content-info-fila col-12">
                    <b class="mr-2">Tipo de comunicación:</b>
                    <span>{{ snp.tipoSeguimiento.nombre }}</span>
                  </label>
                  <label class="content-info-fila col-12">
                    <b class="mr-2">Agente</b>
                    <span>{{ snp.agente.id }} - {{ snp.agente.nombre }}</span>
                  </label>
                  <label class="content-info-fila col-12">
                    <b class="mr-2">Fecha:</b>
                    <span
                      class="{{seguimientoProgramadoMenor.fechaProgramada === snp.fechaProgramada ? 'tc-red': ''}}">
                      {{ snp.fechaProgramada | date: 'dd/MM/yyyy' }} {{ snp.fechaProgramada | date:'shortTime' }}
                    </span>
                  </label>
                  <label class="content-info-fila col-12" *ngIf="snp.enlace">
                    <b class="text-color-black-75 mr-2">Enlace</b>
                    <span class="color-primario-linnegocios">
                      <a href="{{snp.enlace}}" target="_blank">{{ snp.enlace }}</a>
                    </span>
                  </label>
                </div>
              </mat-card-content>
            </mat-card>
          } @else {
            <div class="p-3 tc-gray">
              No hay seguimientos programados pendientes.
            </div>
          }
        </mat-menu>

        <button
          mat-button
          mat-stroked-button
          class="mr-2 button-chat mat-badge-cuartenario"
          [class.parpadea]="totalChats > 0"
          (click)="drawerAdminChats.toggle()"
          [matBadge]="totalChats"
          matBadgeSize="large"
          [matBadgeHidden]="totalChats == 0"
        >
          <span>CHATS</span>
          <mat-icon>support_agent</mat-icon>
        </button>
        <button mat-icon-button
                [matMenuTriggerFor]="appMenu">
          <mat-icon>account_circle</mat-icon>
        </button>
        <mat-menu #appMenu="matMenu">
          <button mat-menu-item (click)="changeCredentials()">
            <mat-icon>lock_person</mat-icon>
            Cambiar contraseña
          </button>

          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            Cerrar sesión

          </button>
        </mat-menu>
      </mat-toolbar>
      <div class="content">
        <router-outlet/>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <ng-container>
    <router-outlet></router-outlet>
  </ng-container>

  <mat-drawer #drawerAdminChats class="chat-admin mt-0 p-0 mat-elevation-z8" mode="side" position="end">
    <button *ngIf="isAuthenticated" mat-button (click)="enableChatNotifications()">Activar avisos de chat</button>
    <app-administrador-chats *ngIf="isAuthenticated"
      (closeAdminChat)="closeAdminChat($event)"
      (selectedChat)="chatSeleccionados($event)">
    </app-administrador-chats>
  </mat-drawer>

  <app-chat
    *ngFor="let chat
     of viewChats; trackBy: trackChat; let i = index" [chat]="chat"
    [ngStyle]="{'right': (340 * i) + 'px'}">
  </app-chat>
</mat-drawer-container>
